import React from "react";
import {menuItemsInfo} from "../editMenuItems";
import {ParamAssignmentsPanel} from "../components/ParamAssignmentsPanel";

export const OutputParamsTab = ({node, onUpdate, project}) => {
    const {primary, secondary} = menuItemsInfo.output_params;
    return (
        <ParamAssignmentsPanel
            node={node}
            onUpdate={onUpdate}
            project={project}
            dataKey="outputs"
            title={primary}
            description={secondary}
        />
    );
};
